var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkillViewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 28,
    viewBox: "0 0 48 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 28,
    rx: 7,
    fill: "#E4F2FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.544 13.045C33.848 13.471 34 13.685 34 14C34 14.316 33.848 14.529 33.544 14.955C32.178 16.871 28.689 21 24 21C19.31 21 15.822 16.87 14.456 14.955C14.152 14.529 14 14.315 14 14C14 13.684 14.152 13.471 14.456 13.045C15.822 11.129 19.311 7 24 7C28.69 7 32.178 11.13 33.544 13.045Z",
    stroke: "#378BCB",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 14C27 13.2044 26.6839 12.4413 26.1213 11.8787C25.5587 11.3161 24.7956 11 24 11C23.2044 11 22.4413 11.3161 21.8787 11.8787C21.3161 12.4413 21 13.2044 21 14C21 14.7956 21.3161 15.5587 21.8787 16.1213C22.4413 16.6839 23.2044 17 24 17C24.7956 17 25.5587 16.6839 26.1213 16.1213C26.6839 15.5587 27 14.7956 27 14Z",
    stroke: "#378BCB",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillViewIcon);
export default __webpack_public_path__ + "static/media/skill-view-icon.d52c6c6f22fe505533ed89273a41b411.svg";
export { ForwardRef as ReactComponent };